.donut-chart {
  position: relative;
  display: grid;
  place-self: center;
  width: 100%;
  min-height: 240px;
  max-height: 480px;
  aspect-ratio: 1;
  padding: var(--mantine-spacing-sm);

  > * {
    width: 100%;
    height: 100%;
  }

  :fullscreen & {
    place-self: stretch;
    max-height: none;
    aspect-ratio: auto;
  }
}

.center-overlay {
  position: absolute;
  inset: 0;
  display: grid;
  place-content: center;
  place-items: center;
  pointer-events: none;
  border: 1px solid red;
}

.center-value {
  font-size: var(--mantine-font-size-xl);
  font-weight: 700;
  line-height: 1.1;
  color: var(--mantine-color-text);
  fill: var(--mantine-color-text);
}

.center-label {
  font-size: var(--mantine-font-size-sm);
  color: var(--mantine-color-dimmed);
  fill: var(--mantine-color-dimmed);
}

.tooltip {
  /* FIXME: deduplicate */
  :global {
    display: flex;
    flex-flow: column nowrap;
    gap: var(--mantine-spacing-xs);
    padding: var(--mantine-spacing-xs);
    font-size: var(--mantine-font-size-sm);
    white-space: nowrap;
    /* biome-ignore lint/complexity/noImportantStyles: overrides recharts' inline tooltip element style */
    background-color: alpha(var(--mantine-color-dark-8), 0.7) !important;
    /* biome-ignore lint/complexity/noImportantStyles: overrides recharts' inline tooltip element style */
    border: 1px solid var(--mantine-color-dark-4) !important;
    border-radius: var(--mantine-radius-sm);
    box-shadow: var(--mantine-shadow-sm), var(--mantine-shadow-lg);
    backdrop-filter: blur(var(--mantine-radius-md));
    :empty {
      display: none;
    }
    :has(> &) {
      z-index: 100;
    }
    .recharts-tooltip-label {
      font-size: var(--mantine-font-size-lg);
      font-weight: 600;
    }
    .recharts-tooltip-item-list {
      display: grid;
      grid-template-columns: repeat(3, auto);
      gap: var(--mantine-spacing-xs);
      align-items: baseline;
    }
    .recharts-tooltip-item {
      /* biome-ignore lint/complexity/noImportantStyles: overrides recharts' inline tooltip-item display style */
      display: contents !important;
      padding: 0;
    }
    .recharts-tooltip-item-name {
      &::before {
        display: inline-block;
        width: 0.5rem;
        height: 0.5rem;
        margin-inline-end: var(--mantine-spacing-xs);
        vertical-align: center;
        content: '';
        background: currentColor;
      }
    }
    .recharts-tooltip-item-separator {
      display: none;
    }
    .recharts-tooltip-item-value {
      font-weight: 600;
      color: var(--mantine-color-dark-0);
    }
    .recharts-tooltip-item-unit {
      font-size: var(--mantine-font-size-xs);
      color: var(--mantine-color-dark-0);
    }
  }
}
